import { ANALYTICS_LINK_TYPES } from '../constants'

export const callAnalyticsLink = (linkType, linkTitle, linkLocation) => {
  // make sure ABCMetrics exists
  /* eslint-disable no-undef */
  if (typeof ABVMetrics !== 'undefined') {
    try {
      if (linkTitle !== '') {
        ABVMetrics.processLinkTrack(linkType, 'local', linkTitle, linkTitle, linkLocation)
      }
    } catch (e) {
      // catch all to make sure it doesn't break anything
    }
  }
  /* eslint-enable no-undef */
}

export const wrapAnalyticsLinks = (linkContext, linkLocation) => {
  /* eslint-disable no-undef */
  if (typeof ABVMetrics !== 'undefined') {
    // remove any old bindings
    $('*[data-tag=track-link]', linkContext).unbind('click')

    $('*[data-tag=track-link]', linkContext).click(function () {
      const linkText = $(this).attr('data-analytics-text')
      callAnalyticsLink(ANALYTICS_LINK_TYPES.CUSTOM_LINK, linkText, linkLocation)
      $('*[data-tag=track-link]', linkContext).off('click')
    })

    // remove any old bindings
    $('*[data-tag=track-download]', linkContext).unbind('click')

    $('*[data-tag=track-download]', linkContext).click(function () {
      const linkText = $(this).attr('data-analytics-text')
      callAnalyticsLink(ANALYTICS_LINK_TYPES.DOWNLOAD_LINK, linkText, linkLocation)
    })
  }
  /* eslint-enable no-undef */
}



// WEBPACK FOOTER //
// ./src/helpers/analytics.js